module.exports = __webpack_public_path__ + "img/swipe.633140bf.gif";